module.exports = __webpack_public_path__ + "static/media/audio.6f6cc2b2.mp3";